import { render, staticRenderFns } from "./affiliatedEnterprises.vue?vue&type=template&id=c57f1266"
import script from "./affiliatedEnterprises.vue?vue&type=script&lang=js"
export * from "./affiliatedEnterprises.vue?vue&type=script&lang=js"
import style0 from "./affiliatedEnterprises.vue?vue&type=style&index=0&id=c57f1266&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports